<script setup lang="ts">
defineEmits<{
  click: [];
}>();
</script>

<template>
  <button
    type="button"
    class="bg-white rounded-full w-8 h-8 min-w-8 min-h-8 border border-neutral300 shadow-small z-50 hover:bg-neutral100 transition-colors focus-visible-base"
    @click="$emit('click')"
  >
    <slot>
      <i class="fas fa-ellipsis"></i>
    </slot>
  </button>
</template>
